(ns storrito.connect3.success-panel
  (:require [ui.gallery.link :as gallery-link]))

(defn- success-icon
  "Renders the IG profile picture when the connect3 save handler has
   stored it as a local blob (`:profile-picture-url` is a `/image/<id>`
   URL). Falls back to the green checkmark when the server didn't manage
   to download the picture — the IG CDN blocks hot-linking, so we never
   render the raw IG URL."
  [state]
  (if-let [pic-url (:profile-picture-url state)]
    [:div.flex.justify-center.mb-6
     [:img.w-20.h-20.rounded-full.object-cover.ring-4.ring-green-100
      {:src pic-url
       :alt (str (:user state) " profile picture")}]]
    [:div.flex.justify-center.mb-6
     [:div.w-16.h-16.bg-green-100.rounded-full.flex.items-center.justify-center
      [:svg.w-8.h-8.text-green-600
       {:fill "none"
        :stroke "currentColor"
        :viewBox "0 0 24 24"
        :stroke-width "2"}
       [:path {:stroke-linecap "round"
               :stroke-linejoin "round"
               :d "M5 13l4 4L19 7"}]]]]))

(defn- error-banner
  [state]
  (when (:error-message state)
    [:div.mb-6.p-4.bg-red-50.border.border-red-200.rounded-lg
     [:div.flex.items-center
      [:svg.w-5.h-5.text-red-400.mr-2
       {:fill "none"
        :stroke "currentColor"
        :viewBox "0 0 24 24"
        :stroke-width "2"}
       [:path {:stroke-linecap "round"
               :stroke-linejoin "round"
               :d "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}]]
      [:span.text-red-800 (:error-message state)]]]))

(defn panel
  [state]
  (let [connect-link? (:connect-link state)]
    [:div.flex.flex-col.items-center.justify-center.p-6
     [:div.max-w-xl.w-full.bg-white.rounded-2xl.shadow-xl.p-8.text-center
      (success-icon state)

      [:h1.text-3xl.font-bold.text-gray-900.mb-4
       "Connection Successful!"]

      [:div.text-lg.text-gray-600.mb-6
       [:p.mb-2 "You have successfully connected the Instagram account"]
       [:p.font-semibold.text-blue-600
        (str "'" (:user state) "'")]]

      (error-banner state)

      (if connect-link?
        [:div.mt-2.text-sm.text-gray-500
         "You can close this window now. The account owner will be able to manage this Instagram account from their Storrito dashboard."]
        [:div.space-y-4
         [:div.p-3.rounded-lg.bg-green-50.border.border-green-200.text-sm.text-green-700.mb-2
          (if-let [amount (:free-plan.trial/start-credit-amount-formatted state)]
            (str "The first " amount " are on us – no credit card needed.")
            "Your first stories are on us – no credit card needed.")]
         [:a.button.w-full.px-6.py-4.bg-green-600.text-white.rounded-lg.font-semibold.text-lg.hover:bg-green-700.transition-all.duration-200.shadow-lg.hover:shadow-xl
          {:type "button"
           :href (gallery-link/gallery-href (:auto-fill/folder-uuid state))
           ;; Funnel signal between the connect and the first content:
           ;; without it a signup that stops at this panel and one that
           ;; goes on to the gallery look the same in the logs.
           :on {:click [[:client-log/log :onboarding/connect-success-continued]]}}
          [:div.flex.items-center.justify-center
           "Post your first story"
           [:svg.size-6.ml-2
            {:xmlns "http://www.w3.org/2000/svg"
             :fill "none"
             :viewBox "0 0 24 24"
             :stroke-width "1.5"
             :stroke "currentColor"}
            [:path
             {:stroke-linecap "round"
              :stroke-linejoin "round"
              :d "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"}]]]]])]]))
